import styled from '@emotion/styled';
import { Button } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { peach } from 'constants/blogColors';
import { SingleArticleQuery_articleCollection_items_body_links_entries_block_InArticleCtaContainer_fallbackCta } from 'graphql/__generated__/operations/SingleArticleQuery';
import { useRouter } from 'next/router';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { Headline } from './CTACommonStyles';

type props = {
  inArticleCTA: SingleArticleQuery_articleCollection_items_body_links_entries_block_InArticleCtaContainer_fallbackCta;
};

export const PersonaBasedCTA = ({ inArticleCTA }: props) => {
  const { headline, buttonText, buttonUrl, image } = inArticleCTA;
  const trackEvent = useTrackEvent();
  const router = useRouter();
  return (
    <CTAWrapper>
      <ImageWrapper>
        <Image src={image?.url!} alt={image?.description ?? 'Persona image'} />
      </ImageWrapper>
      <ActionSection>
        <HeadlineStyled>{headline}</HeadlineStyled>
        <ButtonWrapper>
          <Button
            target="_blank"
            href={buttonUrl!}
            color="black"
            size="small"
            onClick={() => {
              trackEvent('call_to_action', {
                path: window.location.pathname,
                from_path: document.referrer,
                cta_name: 'find_a_workflow',
                cta_raw_text: headline!,
                cta_location: router.asPath,
                cta_goal: 'get_more_information',
                link_destination: buttonUrl!,
              });
            }}
          >
            {buttonText}
          </Button>
        </ButtonWrapper>
      </ActionSection>
    </CTAWrapper>
  );
};

const CTAWrapper = styled.article`
  border-radius: 5px;
  background-color: ${peach};
  display: flex;
  flex-direction: column;
  padding: 30px 20px;
  ${mediaQueries.tablet} {
    flex-direction: row;
    padding: 20px 40px 20px 30px;
  }
`;

const ActionSection = styled.section`
  flex: 2;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 20px;
  ${mediaQueries.tablet} {
    margin: 10px 20px 10px 0px;
    text-align: left;
    order: 1;
  }
`;

const ImageWrapper = styled.aside`
  flex: 1;
  text-align: center;
  ${mediaQueries.tablet} {
    text-align: right;
    order: 2;
    flex: 0;
  }
`;

const Image = styled.img`
  border-radius: 50%;
  height: 128px;
  object-fit: cover;
  width: 128px;
  ${mediaQueries.tablet} {
    width: 168px;
    height: 168px;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;
`;

const HeadlineStyled = styled(Headline)`
  max-width: 400px;
  margin: 0 auto;
  ${mediaQueries.tablet} {
    margin: 0;
  }
`;
